"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SelectPrimitive = require("@radix-ui/react-select");
const classNames_1 = require("../../../../../utils/classNames");
const lucide_react_1 = require("lucide-react");
exports.SelectItem = (0, react_1.forwardRef)(({ className, children, indicator = { show: true }, ...props }, ref) => ((0, jsx_runtime_1.jsxs)(SelectPrimitive.Item, { ref: ref, className: (0, classNames_1.cn)('aries-select__item flex w-full flex-row items-center justify-between align-middle', className), ...props, children: [(0, jsx_runtime_1.jsx)(SelectPrimitive.ItemText, { children: children }), indicator?.show ? ((0, jsx_runtime_1.jsx)(SelectPrimitive.ItemIndicator, { children: indicator.element ? ((0, react_1.cloneElement)(indicator.element, {
                className: 'h-4 w-4',
            })) : ((0, jsx_runtime_1.jsx)(lucide_react_1.Check, { className: "h-4 w-4" })) })) : null] })));
